module.exports = __webpack_public_path__ + "img/intro-screen04.9cd35ef6.png";